import React from 'react';
import SubNavbar from '../../components/SubNavbar';
import ContactBox from '../../components/ContactBox';

const BlogPost1 = () => {
  return (
    <div className="white-page">
      <SubNavbar />
      
      <div className="page-content-wrapper">
        <div className="photo-collections">
        </div>
      </div>
    </div>
  );
};

export default BlogPost1;
